import Icon from '../../components/Icon.vue'

Icon.register({"brands/twitch":{"width":448,"height":512,"paths":[{"d":"M40.1 32L10 108.9V423.2H117V480H177.2L234 423.2H321L438 306.2V32H40.1zM397.9 286.1L331 353H224L167.2 409.8V353H76.9V72.1H397.9V286.1zM331 149V265.9H290.9V149H331zM224 149V265.9H183.9V149H224z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/twitch.js
// module id = VzXb
// module chunks = 0